import { render, staticRenderFns } from "./couponModal.vue?vue&type=template&id=47ea46e5&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./couponModal.vue?vue&type=style&index=0&id=47ea46e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea46e5",
  null
  
)

export default component.exports